define('lq/events/actions/backgroundTask',[
    'lq/events/actions/eventAction',
    'lq',
    'when'
], function (EventAction, lq, when) {
    'use strict';

    var pollDelayInMilliseconds = 1000;

    function BackgroundTask(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(BackgroundTask, EventAction);

    BackgroundTask.typeName = 'BackgroundTask';

    BackgroundTask.prototype.getBatchType = function () {
        return this.pollForProgress() ? EventAction.DO_NOT_BATCH : EventAction.COMMAND_BATCH;
    };

    BackgroundTask.prototype.createEventActionRequest = function () {
        if (!this.pollForProgress()) {
            return {
                eventActionType: "BackgroundTask",
                morphId: this.eventData.commandId
            };
        }
    };

    BackgroundTask.prototype.pollForProgress = function () {
        return this.eventData.waitUntilReady || this.eventIsEnabled('completed');
    };

    BackgroundTask.prototype.updateProgress = function (data) {
        if (data.progress !== this.lastBatchProgress) {
            this.lastBatchProgress = data.progress;
            this.triggerEventIfEnabled('batchProgressChanged', undefined, data.progress);
        }

        if (data.total !== this.lastBatchTotal) {
            this.lastBatchTotal = data.total;
            this.triggerEventIfEnabled('batchTotalChanged', undefined, data.total);
        }
    }

    BackgroundTask.prototype.execute = function (continuation, eventActionResponse) {
        var self = this;
        var piping = this.piping;

        if (!this.eventData.waitUntilReady) {
            continuation();

            if (!this.pollForProgress()) {
                return;
            }
        }
        else {
            piping.busyIndicator.show();
        }

        function completed() {
            if (self.eventData.waitUntilReady) {
                piping.busyIndicator.hide();
                continuation();
            }

            self.triggerEventIfEnabled('completed');
        }

        this.piping.dispatcher.dispatchToAbsoluteUrl(
            this.piping.url.prepare(lq.getTenantUrl('BackgroundTask/'), {}),
            {
                actionId: this.rootDrop.data.id,
                commandId: this.eventData.commandId,
                globals: piping.parameters.globals.getAll(),
                locals: piping.parameters.locals.getAll()
            })
            .then(function (response) {
                if (!response.ticketNumber) { // neither "wait until ready" or "completed" event is enabled
                    completed();
                } else {
                    function isReady() {
                        return $.get({
                            url: lq.getTenantUrl('BackgroundTask/IsReady'),
                            data: {
                                ticketNumber: response.ticketNumber
                            },
                            cache: false
                        });
                    }

                    function poll(operation) {
                        return when.promise(function (resolve, reject, notify) {
                            setTimeout(function () {
                                resolve(operation()
                                    .always(function (data, textStatus, xhr) {
                                        if (xhr.status === 202) {
                                            self.updateProgress(data);
                                            return poll(operation);
                                        } else if (xhr.status === 200) {
                                            self.updateProgress(data);
                                            completed();
                                        }
                                    }));
                            },
                            pollDelayInMilliseconds);
                        });
                    }

                    poll(isReady);
                }
            })
            .catch(function () {
                alert('Something went wrong while running the background task.');
            });
    };

    return BackgroundTask;
});
